module.exports = __webpack_public_path__ + "img/introduce.3d961e55.png";